export const _DEBUG_STROKE_TIME_STAMP = false;
//# sourceMappingURL=index.js.map